export default __webpack_public_path__ + "static/media/G_wdt_c_cap_4.a5e0c457.mp3";